import React, { useState } from 'react'
import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from '@mui/icons-material/Clear';
import createfolderlogo from "../../../Assets/createfolderlogo.svg"
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import Delete from "../../../Assets/Delete.svg"
import disabledelete from "../../../Assets/disabledelete.png"
import publicLock from "../../../Assets/publicLock.svg"
import privateLock from "../../../Assets/privateLock.svg"
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal, Button,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { toast } from "react-toastify";
import publiclockdiabled from "../../../Assets/publiclockdiabled.svg"
import moment from "moment";
import privateLockDisable from "../../../Assets/privatelockdisabled.svg"
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg"
import decisionMakerImage from "../../../Assets/Cloudfigma.svg"
import ContactDetailList from '../../AiLeads/ContactDetailList/ContactDetailList';
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  GetOktaAuthData,
  GetUserId,
  logEvent,
} from "../../../Utils/Utils";
import IndustryDropdown from "../../AiLeads/IndustrySectorDropdown/Index";
import RightSidebar from '../../RightSiderbar/RightSiderbar';
function Row({
  key,
  row,
  ExpandHandler,
  expandHandlerAccept,
  selectedRows,
  setSelectedRows,
  setPageInner,
  pageInner,
  openRowId,
  onLoadApi,
  setHasMoreInner,
  setopenRowId,
  totalPages,
  selectedOuterRows, organizationList,
  setOrganizationList, listOrganizationSearchResults,
  handleRowSelect, showLeadsProspects, setoOenCreateListmdl
  , setOpenCreateMdl, setSelectedOption, setUpdatelist, setListName,
  setUpdatedId, setSelectedListId, setOpenDeleteModal, disableOrganizationData,
  selectedOrganizationData, selectedListId, innerDataNew, searchResultPeople,
  searchResultProspects, handleOrganizationsearch, handlePeoplesearch, headerSearchDataPeople, showLoading
}) {
  const userId = GetUserId();
  const navigate = useNavigate();
  const [innerTableData, setInnerTAbleData] = React.useState([]);
  const [sortField, setSortField] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [scrollPagination, setScrollPagination] = useState(false);
  const [loading, setLoading] = useState();
  const loggedInUserId = GetUserId();
  const [sortOrder, setSortOrder] = React.useState(null);
  const getColor = (aiScore) => {
    if (aiScore > 80) {
      return "green";
    } else if (aiScore >= 50 && aiScore <= 80) {
      return "yellow";
    } else {
      return "red";
    }
  };

  const [rowsSelect, setRowsSelect] = useState(false);
  const [dataShortestPath, setDataShortestPath] = React.useState();
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [userDetails, setUserDeatils] = React.useState();
  const handleAllSelectCollapsible = () => {
    if (rowsSelect) {
      const newList = innerTableData
        ?.map((info) => ({ ...info, organizationInfo: row }))
      setSelectedRows(newList);
    } else {
      setSelectedRows([]);
    }
  };


  const onExpand = (event) => {
    setLoading(true);
    setOpen(true);
    onLoadApi(event)
      .then((e) => {
        const childData = e;

      })
      .catch(() => {
        setLoading(false);
        setOpen(false);
      });
  };
  const handleRightsidebar = (event) => {
    logEvent("shortest-path", "JOI");
    const data = {};
    data.source_uid = Number(userId);
    data.target_uid = Number(event?.people_details?.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken()
      },
      data: data,
      url: `${APIUrlTwo()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          const data = Object.values(response.data);
          setDataShortestPath(data);
          setOpenSidebar(true);
          setUserDeatils(event)
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const ExpandHandlerChild = (event) => {
    setLoading(true);
    ExpandHandler(event)
      .then((e) => {
        const childData = e;
        setLoading(false);
        if (e?.status === 200) {
          const innerdata = e?.data?.data;
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (expandHandlerAccept?.length > 0) {
      setInnerTAbleData([...expandHandlerAccept]);
    }
  }, [expandHandlerAccept]);


  const clickHandler = (event) => {
    navigate(`/companyprofilescreen/${event?.org_id}/0`);
  };

  React.useEffect(() => {
    if (
      innerDataNew?.length >= 20 &&
      row?.user_favourite_list_id || row?.favourite_list_id === openRowId &&
      pageInner > 1 &&
      pageInner <= Math.ceil(pages)
    ) {
      setHasMoreInner(false);
      ExpandHandlerChild(openRowId);
    }
  }, [pageInner]);

  const pages = row?.fav_leads_count || row?.fav_count / 20;

  const closeExpandHandler = () => {
    setInnerTAbleData([]);
    setOpen(false);
    setopenRowId("");
    setScrollPagination(false);
  };

  React.useEffect(() => {
    handleAllSelectCollapsible();
  }, [rowsSelect]);
  const ref = React.useRef(null);
  const isBranchLocationsDisabled = true;

  const loadMore = () => {
    setLoading(true);
    setPageInner(prevPageInner => prevPageInner + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleSort = (field) => {
    let newSortOrder;
    if (sortField === field) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }
    setSortOrder(newSortOrder);
    setSortField(field);

    const employeeOrder = [
      "1-10", "11-50", "51-100", "101-250", "251-500", "501-1000",
      "1K-5K", "5K-10K", "10K+"
    ];

    const revenueOrder = [
      "$0-$1m", "$0-$1M", "$1m-$10m", "$1M-$10M", "$10m-$50m", "$10M-$50M", "$50m-$100m", "$50M-$100M",
      , "$100m-$500m", "$100M-$500M", "$500m-$1b", "$500M-$1B", "$1b-$10b", "$1B-$10B", "$10b+", "$10B+"
    ];

    const getOrderIndex = (value, orderArray) => {
      const index = orderArray.indexOf(value);
      return index !== -1 ? index : orderArray.length;
    };

    const sortedData = [...organizationList].sort((a, b) => {
      let aValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], a)
        : a[field];
      let bValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], b)
        : b[field];

      const isEmpty = (val) => val === null || val === "" || val === "-";
      const aIsEmpty = isEmpty(aValue);
      const bIsEmpty = isEmpty(bValue);

      if (aIsEmpty && !bIsEmpty) return 1;
      if (!aIsEmpty && bIsEmpty) return -1;
      if (aIsEmpty && bIsEmpty) return 0;

      if (field === "updated_at") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (field === "num_employees") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, employeeOrder) - getOrderIndex(bValue, employeeOrder)
          : getOrderIndex(bValue, employeeOrder) - getOrderIndex(aValue, employeeOrder);
      }

      if (field === "revenue_range") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, revenueOrder) - getOrderIndex(bValue, revenueOrder)
          : getOrderIndex(bValue, revenueOrder) - getOrderIndex(aValue, revenueOrder);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return newSortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue instanceof Date && bValue instanceof Date) {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });

    setOrganizationList(sortedData);
  };
  const isDefault = row?.fav_is_default;


  const handleOpenListMdlUpdate = (name, id) => {
    setoOenCreateListmdl(true);
    setOpenCreateMdl(false);
    setSelectedOption("")
    setListName(name);
    setUpdatelist(true);
    setUpdatedId(id)
  }

  const handleOpenDeleteModal = (id) => {
    setSelectedListId(id);
    setOpenDeleteModal(true);
  };


  // get favourite list api
  const getFavList = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken()
      },
      url: `${APIUrlThree()}/v1/get_favourite_list_org?user_id=${userId}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setOrganizationList(e?.data.data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }
  React.useEffect(() => {
    getFavList()
  }, [])


  const handlePrivacyClick = (id) => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/isprivate_favourite_list?id=${id}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          if (headerSearchDataPeople) {
            handlePeoplesearch();
          } else {
            handleOrganizationsearch();
          }
          // getFavList();
          toast.success(e?.data?.message)
        }
      })
      .catch((err) => {
        console.error('Error enriching prospect', err);
        setLoading(false);
      });
  };

  return (
    <React.Fragment key={key}>
      {/* {loading ? <Loader /> : null} */}
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
      // style={{ cursor: "pointer" }}
      >

        <>
          <TableCell>
            <div>
              <input type="checkbox" name="" id="" />
            </div>
          </TableCell>
          <TableCell align="center">
            {searchResultPeople ?
              <h3 className="employee-size-table">
                {row?.first_name} {" "} {row.last_name}
              </h3>
              :
              <h3 className="employee-size-table">
                {row?.name}
              </h3>
            }

          </TableCell>
          <TableCell align="center">
            <h3 className="employee-size-table">
              {row?.fav_name ? row?.fav_name : "-"}
            </h3>
          </TableCell>
          <TableCell align="center">
            <h3 className="employee-size-table">
              {row?.fav_created_date
                ? moment(row?.fav_created_date).format("DD MMM YYYY")
                : "-"}
            </h3>
          </TableCell>
          {/* <TableCell align="left">
            <div
              onClick={() => !isDefault && handlePrivacyClick(row?.id)}
              className="privacy-status-tr"
              style={{
                color: isDefault ? "grey" : "inherit",
                cursor: isDefault ? "not-allowed" : "pointer",
              }}
            >
              <h3 className="annual-revenue-table">
                {row?.is_private ? "Private" : "Public"}
              </h3>
              <img
                src={row?.is_private ? privateLock : publicLock}
                alt="My Lists"
              />
            </div>
          </TableCell> */}
          {/* <TableCell align="left">
            <div
              className="privacy-status-tr"
              style={{
                color: "grey",
                cursor: "not-allowed",
              }}
            >
              <h3 className="annual-revenue-table">
                {row?.fav_is_private ? "Private" : "Public"}
              </h3>
              <img style={{
                color: "grey",
                cursor: "not-allowed",
              }}
                src={row?.fav_is_private ? privateLock : publiclockdiabled}
                alt="My Lists"
              />
            </div>
          </TableCell> */}
          <TableCell align="left" style={{ cursor: 'not-allowed' }}>
            <div
              // onClick={() => !isDefault && handlePrivacyClick(row?.id)}
              className="privacy-status-tr"
              style={{
                color: isDefault ? "grey" : "grey",
                // cursor: isDefault ? "not-allowed" : "pointer",
              }}
            >
              <h3 className="annual-revenue-table">
                {row?.fav_is_private ? "Private" : "Public"}
              </h3>
              <img
                // src={row?.is_private ? privateLock : publicLock}
                src={row?.fav_is_default ? privateLockDisable : row?.fav_is_private ? privateLock : publicLock}
                alt="My Lists"
              />
            </div>
          </TableCell>
          <TableCell align="left">
            <h3 className="employee-size-table">
              {row?.fav_first_name ? row?.fav_first_name : "-"}{" "}
              {row?.fav_last_name ? row?.fav_last_name : "-"}
            </h3>
          </TableCell>
          <TableCell align="left">
            <h3 className="employee-size-table">{row?.fav_leads_count || row?.fav_count}</h3>

          </TableCell>
          <TableCell>
            <TableCell align="right" className="three-dot-cell">
              <span
                className="threeDotIcon-table-profile"
                style={{
                  color: "grey",
                  cursor: "not-allowed",
                }}
              >
                <img src={disabledelete} alt="" />
              </span>
              <span
                className="threeDotIcon-table-profile"
                style={{
                  color: "grey",
                  cursor: "not-allowed",
                }}
              >
                <DriveFileRenameOutlineIcon />
              </span>
              <span
                className=""
              // onClick={() => handleExpandRecords(row?.id)}
              >
                <Tooltip title={open ? "Collapse" : "Expand"}>
                  {open ? (
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => closeExpandHandler()}
                      className="threeDotIcon-table-profile"
                    >
                      <RemoveRoundedIcon className="icon-collapse-table" />
                    </IconButton>
                  ) : (
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => {
                        setInnerTAbleData([]);
                        setHasMoreInner(false);
                        setTimeout(() => {
                          if (openRowId !== row?.user_favourite_list_id || row?.favourite_list_id) {
                            setLoading(true);
                            setPageInner(1);
                            setopenRowId(row?.user_favourite_list_id || row?.favourite_list_id);
                            onExpand(row?.user_favourite_list_id || row?.favourite_list_id);
                          }
                        }, 0);
                      }}
                      className="threeDotIcon-table-profile"
                    >
                      <AddIcon className="icon-collapse-table" />
                    </IconButton>
                  )}
                </Tooltip>
              </span>
            </TableCell>
          </TableCell>
        </>
      </TableRow>
      {innerDataNew?.some(item => item.organization_details) ?

        (
          innerDataNew?.length ?
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box
                  sx={{ margin: 1 }}
                  id="scrollableDiv"
                  className="ai-leads-table-inner"
                  ref={ref}
                >
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" className="ai-leads-table">
                      <TableHead>
                        <TableRow className="row-head">
                          <TableCell className="checkbox-row-table-inner checkbox-row-table">

                            <input
                              type="checkbox"
                              disabled={disableOrganizationData}
                              onChange={(e) => setRowsSelect(e?.target?.checked)}
                              checked={rowsSelect}
                            />
                            {/* } */}
                          </TableCell>
                          <TableCell className="empty-name-and-title">
                            JOI Score
                          </TableCell>

                          <TableCell className="company-row-table">
                            Organization & Location
                          </TableCell>
                          <TableCell
                            align="left"
                            className="score-row-table-New-Data"
                          >
                            Employee Size
                          </TableCell>
                          <TableCell
                            align="left"
                            className="employee-row-table-innerIndustryAndSector"
                          >
                            <p className="sector-industry"> Annual Revenue</p>
                          </TableCell>
                          <TableCell
                            align="left"
                            className="annual-row-table-NewJOSFStatus"
                          >
                            Industry/ Sector
                          </TableCell>
                          <TableCell align="left" className="industry-row-table-inner-table">
                            Employees
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {innerDataNew?.some(item => item.organization_details) ?
                          (
                            innerDataNew
                              .slice()
                              .sort((a, b) => {
                                if (a.decision_maker && !b.decision_maker) return -1;
                                if (!a.decision_maker && b.decision_maker) return 1;
                                return (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0);
                              })
                              .map((row, index) => (
                                <React.Fragment key={index}>
                                  <TableRow key={index} sx={{ "& > *": { borderBottom: "unset" } }}>
                                    <TableCell>
                                      <input
                                        type="checkbox"
                                        disabled={disableOrganizationData}
                                        onChange={() => handleRowSelect(row)}
                                        checked={selectedOrganizationData?.some(
                                          (item) =>
                                            item?.organization_details?.org_id ===
                                            row?.organization_details?.org_id
                                        )}
                                      />
                                    </TableCell>
                                    <TableCell component="th" scope="row" onClick={() => clickHandler(row?.organization_details)} style={{ cursor: 'pointer' }}>
                                      <div className="kjhgf">
                                        <div
                                          className="ai-score-background"
                                          style={{
                                            background:
                                              row?.organization_details?.ai_score > 80
                                                ? "#0EB93E"
                                                : row?.organization_details?.ai_score >= 50
                                                  ? "#EAB121"
                                                  : "#DA291C",
                                          }}
                                        >
                                          {row?.organization_details?.ai_score ?? "NA"}
                                        </div>
                                      </div>
                                    </TableCell>
                                    <TableCell align="left" className="companylocation" onClick={() => clickHandler(row?.organization_details)} style={{ cursor: 'pointer' }}>
                                      <h3 className="company-name-country-prospect">
                                        {row.organization_details?.name || "-"}
                                      </h3>
                                      <p className="after-company-name-country-prospect">
                                        {row.organization_details?.city || "-"} {row.organization_details?.state || "-"}
                                      </p>
                                    </TableCell>
                                    <TableCell align="center" onClick={() => clickHandler(row?.organization_details)} style={{ cursor: 'pointer' }}>
                                      <div className="section-employee-size">
                                        <h3 className="employee-size-table">
                                          {row.organization_details?.num_employees || "-"}
                                        </h3>
                                      </div>
                                    </TableCell>
                                    <TableCell align="left" onClick={() => clickHandler(row?.organization_details)} style={{ cursor: 'pointer' }}>
                                      <h3 className="annual-revenue-table">
                                        {row?.organization_details?.revenue_range || "-"}
                                      </h3>
                                    </TableCell>
                                    <TableCell align="left" className="table-cell-of-contact-details-dropdown-th">
                                      <div className="Set-dropdown-ofIndustry" style={{ position: "relative" }}>
                                        <div className="email-andrelative-other-info">
                                          <div className="maked-component-of-dropdown-forai-leads">
                                            <IndustryDropdown row={row?.organization_details} />
                                          </div>
                                        </div>
                                      </div>
                                    </TableCell>
                                    <TableCell align="left" onClick={() => clickHandler(row?.organization_details)} style={{ cursor: 'pointer' }}>
                                      <h3 className="employee-size-table">
                                        {row.leads?.people_count || "-"}
                                      </h3>
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={7} align="center">
                                No records found
                              </TableCell>
                            </TableRow>
                          )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {
                    innerDataNew?.length >= 20 ?
                      <div className="loadmore-pagination-section">
                        {pageInner <= Math.ceil(pages) && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore}>{showLoading ? 'Loading...' : 'Load More'}</button>}
                      </div> : null
                  }
                </Box>
              </Collapse>
            </TableCell>
            : null
        )
        :
        (
          innerDataNew?.length ?
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }} id="scrollableDiv" className="ai-leads-table-inner" ref={ref}
                >
                  <TableContainer component={Paper} style={{ overflowX: 'unset' }}>
                    <Table aria-label="collapsible table" className="ai-leads-table">
                      <TableHead>
                        <TableRow className="row-head">
                          <TableCell className="checkbox-row-table-inner checkbox-row-table">
                            <input
                              type="checkbox"
                              disabled={disableOrganizationData}
                              onChange={(e) => setRowsSelect(e?.target?.checked)}
                              checked={rowsSelect}
                            />
                          </TableCell>
                          <TableCell className="empty-name-and-title"></TableCell>
                          <TableCell className="empty-name-and-title">Name & Title</TableCell>
                          <TableCell className="score-row-table-New-Data">
                            JOI Strength
                          </TableCell>
                          <TableCell align="left" className="score-row-table-New-Data">
                            Organization
                          </TableCell>
                          <TableCell align="left" className="employee-row-table-innerIndustryAndSector">
                            <p className="sector-industry"> Industry/ Sector</p>
                          </TableCell>
                          <TableCell align="left" className="annual-row-table-NewJOSFStatus">
                            JOSF Status
                          </TableCell>
                          <TableCell align="left" className="industry-row-table-inner-table">
                            Contact Details
                          </TableCell>
                          <TableCell align="left" className="industry-row-table-inner-table">
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {innerDataNew?.some(item => item.people_details) ? (
                          innerDataNew
                            ?.slice()
                            ?.sort((a, b) => {
                              if (a.decision_maker && !b.decision_maker) return -1;
                              if (!a.decision_maker && b.decision_maker) return 1;
                              return (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0);
                            })
                            ?.map((row, index) => (
                              <TableRow key={index} sx={{ "& > *": { borderBottom: "unset" } }}>
                                <TableCell>
                                  <input
                                    type="checkbox"
                                    disabled={disableOrganizationData}
                                    onChange={() => handleRowSelect(row)}
                                    checked={selectedOrganizationData.some(item => item.people_details.person_id === row?.people_details.person_id)}
                                  />
                                </TableCell>
                                <TableCell className="Decisions-row-tableName-prospect" align="left">
                                  <div
                                    className={
                                      row?.people_details?.decision_maker === true
                                        ? "Decision-maker-user-name"
                                        : "Decision-maker-user-noborder create-name-img"
                                    }
                                  >
                                    <img
                                      className={
                                        row?.people_details?.suspect_status === null ? "hide-image" : row?.people_details?.journey_status === "project created"
                                          ? "decisionMakerImageAi-Decisionmaker-green" : "decisionMakerImageAi-Decisionmaker"
                                      }
                                      // src={decisionMakerImage}
                                      src={row?.people_details?.journey_status === "project created" ? activeSaleforceLogo : decisionMakerImage}

                                      alt=""
                                    />
                                    <p className="letter-heading">{row?.people_details?.first_name ? row?.people_details?.first_name?.split(" ")?.find(item => !item.includes('('))?.charAt(0) : ""}{row?.people_details?.last_name ? row?.people_details?.last_name?.split(" ")?.find(item => !item.includes('('))?.charAt(0) : ""}</p>
                                  </div>
                                </TableCell>
                                <TableCell className="Decision-maker-userTeblesell_row" align="left" onClick={() => { navigate(`/Profile/${row?.people_details?.person_id == 0 ? "0" : row?.people_details?.person_id}`) }} style={{ cursor: "pointer" }}>          <div className="Decision-maker-user-name-main-container">
                                  <div className="name-and-title-text">
                                    <div className="fullnameofuser">
                                      <h3 className="company-name-country">{row?.people_details?.first_name === "jp" ? "JP" : row?.people_details?.first_name || "-"}&nbsp;
                                        {row?.people_details?.last_name ? row?.people_details?.last_name : "-"}</h3>
                                    </div>
                                    <div className="job-title-container">
                                      <div className="tooltip-container-jobtitle">
                                        <p className={row?.people_details?.raw_job_title ? "tooltip-highlights-jobtitle" : "tooltip-highlights-jobtitle-none"}>
                                          {row?.people_details?.raw_job_title}
                                        </p>
                                        <p className="after-company-name-country-fordecisionmaker">
                                          {row?.people_details?.primary_job_title
                                            ? row.people_details?.primary_job_title.substring(0, 18) +
                                            (row.people_details?.primary_job_title.length > 18 ? "..." : "")
                                            : "-"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <p className="joi-strength-control">{row?.strengthData?.strength ? row?.strengthData?.strength : "-"}</p>
                                </TableCell>
                                <TableCell align="left">
                                  <h3 className="annual-revenue-table">{row.people_details?.primary_organization ? row.people_details?.primary_organization : "-"}</h3>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className="table-cell-of-contact-details-dropdown-th"
                                >
                                  <div
                                    className="Set-dropdown-ofIndustry"
                                    style={{ position: "relative" }}
                                  >
                                    <div className="email-andrelative-other-info">
                                      <div className="maked-component-of-dropdown-forai-leads">
                                        <IndustryDropdown row={row?.people_details} />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align="left">
                                  <div className="Suspect-table-data">
                                    <h3 className="industry-sector-table">
                                      {row?.people_details?.suspect_status ? row?.people_details?.suspect_status : "-"}
                                    </h3>
                                  </div>
                                </TableCell>
                                <TableCell align="left" className="table-cell-of-contact-details-dropdown-th-prospect">
                                  <div
                                    className="Set-dropdown-ofContactDetailList"
                                    style={{ position: "relative" }}
                                  >
                                    <div className="email-and-other-infodc">
                                      <div className="maked-component-of-dropdown">
                                        <ContactDetailList item={row?.people_details} />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className="table-cellhandleRightsidebar-prospect">
                                  <div className="table-cellhandleRightsidebar" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      className="button-collapse-table-propect"
                                    >
                                      <RightSidebar
                                        dataShortestPath={dataShortestPath}
                                        openSidebar={openSidebar}
                                        userDetails={userDetails}
                                        handleRightsidebar={handleRightsidebar}
                                        rowid={row}
                                      />
                                    </IconButton>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={7} align="center">
                              No records found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {
                    innerDataNew?.length >= 20 ?
                      <div className="loadmore-pagination-section">
                        {pageInner <= Math.ceil(pages) && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore}>{showLoading ? 'Loading...' : 'Load More'}</button>}
                      </div> : null
                  }
                </Box>
              </Collapse>
            </TableCell>
            : null
        )}
    </React.Fragment>
  );
}
Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default function OrganizationPeopleSearchShared({
  setIsDecisionMakerExcel, disableOrganizationData,
  isDecisionMakerExcel, setIsSalesForceTrigger,
  isSalesForceTrigger, archiveRecord,
  setArchiveRecord, loading, setLoading, trackRecord,
  setTrackRecord, selectedOuterRows, setSelectedOuterRows,
  setShowSalesForce, showLeadsProspects, selectedRows,
  setSelectedRows, trackingData, handleTrackingdata,
  totalCount, setTotalCount, addToFav, setAddToFav, favoriteSearchData,
  searchResultPeople, searchResultProspects, openRowId, setopenRowId, selectedOrganizationData,
  handleOrganizationsearch, handlePeoplesearch, headerSearchDataPeople
}) {

  const location = useLocation()
  const userInfo = GetOktaAuthData();
  const loggedUser = userInfo?.user?.profile;
  const [hasMoreInner, setHasMoreInner] = React.useState(false);
  const [expandHandlerAccept, setExpandHandlerAccept] = useState([]);
  const [pageInner, setPageInner] = React.useState(1);
  // const [openRowId, setopenRowId] = useState("");
  const [totalPages, setTotalPages] = useState(10);
  const [rowsSelectOuter, setRowsSelectOuter] = React.useState({});
  const [hitApi, setHitApi] = React.useState(false)
  const [hitApiInner, setHitApiInner] = React.useState(false)
  const [rowsSelectAll, setRowsSelectAll] = React.useState(false)
  const [messageModal, setMessageModal] = useState(false)
  const [messageModalTrack, setMessageModalTrack] = React.useState(false)
  const [messageModalSalesforce, setMessageModalSalesforce] = React.useState(false)
  const [skip, setSkip] = useState(0)
  const prevLocationState = React.useRef(location.state);
  const [query, setQuery] = React.useState(location.state);


  // favorite page code starts
  const [selectedOption, setSelectedOption] = useState("organization")
  const userId = GetUserId();
  const [listName, setListName] = useState("");
  const [updatelist, setUpdatelist] = useState(false);
  const [openCreateMdl, setOpenCreateMdl] = useState(false);
  const [openCreateListmdl, setoOenCreateListmdl] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [updatedId, setUpdatedId] = useState();
  const [selectedListId, setSelectedListId] = useState(null);
  const [organizationList, setOrganizationList] = useState();
  const [innerDataNew, setInnerDataNew] = useState();
  const [showLoading, setShowLoading] = useState(false)


  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };

  const handleOpen = () => {
    setSelectedOption("organization");
    setOpenCreateMdl(true);
  };
  const handleClose = () => {
    setOpenCreateMdl(false);
    setSelectedOption("")
  }

  const handleOpenListMdlUpdate = (name, id) => {
    setoOenCreateListmdl(true);
    setOpenCreateMdl(false);
    setSelectedOption("")
    setListName(name);
    setUpdatelist(true);
    setUpdatedId(id)
  }
  const handleOpenListMdl = () => {
    setoOenCreateListmdl(true);
    setOpenCreateMdl(false);
    setSelectedOption("")
  }
  const handleCloseListMdl = () => {
    setoOenCreateListmdl(false);
    setListName("")
    setUpdatelist(false);
  }
  const handleOpenDeleteModal = (id) => {
    setSelectedListId(id);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  // get favourite list api
  const getFavList = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken()
      },
      url: `${APIUrlThree()}/v1/get_favourite_list_org?user_id=${userId}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setOrganizationList(e?.data.data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }
  React.useEffect(() => {
    getFavList()
  }, [])

  // create favourite list api
  const saveOrgFavList = () => {
    if (!listName.trim()) {
      toast.error("Please Type List Name");
      return;
    }
    setLoading(true);
    const data = {
      user_id: userId,
      name: listName,
      isPrivate: true,
      type: selectedOption,

    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/save_favourite_list_org`,
      data: data,
    };
    axios(option)
      .then((e) => {

        setLoading(false);
        if (e?.status === 200) {
          getFavList();
          toast.success(e?.data?.message)
          setoOenCreateListmdl(false)
          setListName("");
        }

      })
      .catch((err) => {
        console.error('Error enriching prospect', err);
        setLoading(false);
      });
  };

  // delete list
  const deleteFavList = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      data: [selectedListId],
      url: `${APIUrlThree()}/v1/delete_favourite_list`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          getFavList();
          toast.success(e?.data?.message)
          setOpenDeleteModal(false)
        }

      })
      .catch((err) => {
        console.error('Error enriching prospect', err);
        setLoading(false);
      });
  };



  const updateOrgFavList = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/update_favourite_list_name?id=${updatedId}&name=${listName}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          getFavList();
          setoOenCreateListmdl(false)
          toast.success(e?.data?.message)
        }
      })
      .catch((err) => {
        console.error('Error enriching prospect', err);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (location.state !== prevLocationState.current) {
      setOrganizationList([]);
    }
    prevLocationState.current = location.state;
    setQuery(location.state);
  }, [location.state]);
  //get search list results
  const listOrganizationSearchResults = async (isFav) => {
    // setLoading(true)
    // const options = {
    //   method: "POST",
    //   headers: {
    //     "access-control-allow-origin": "*",
    //     "content-type": "application/json",
    //     "X-API-Key": APIUrlToken()
    //   },
    //   data: { "org_name": query },
    //   url: `${APIUrlThree()}/v1/universal_search_org?skip=${skip * 50}&limit=50`,
    // };
    // try {
    //   const response = await axios(options);
    //   setTotalCount(response?.data?.total_records)
    //   if (isFav) {
    //     setOrganizationList([...response?.data?.data])
    //   } else {
    //     setOrganizationList([...organizationList, ...response?.data?.data])
    //   }
    // } catch (error) {
    //   setLoading(false);
    //   toast.error(error?.response?.data?.message);
    // } finally {
    //   setLoading(false);
    // }
  }

  React.useEffect(() => {
    listOrganizationSearchResults()
  }, [skip, query])

  // pagination 
  const loadMore = () => {
    setLoading(true);
    setSkip(prev => prev + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  //sorting

  //expand inner handler
  const ExpandHandler = (event, page) => {
    setopenRowId(event);
    setShowLoading(true)
    const option = {
      method: "POST",
      headers: {
        "content-type": "plain/text",
        "X-API-Key": APIUrlToken()
      },
      url: `${APIUrlThree()}/v1/get_list?id=${event}&limit=20&skip=${(pageInner - 1) * 20}`,
    };
    return axios(option).then((e) => {
      setShowLoading(false)
      if (e?.status === 200) {
        setTotalPages(10)
        const innerdata = e?.data;
        if (innerdata?.length === 0) {
          setHasMoreInner(false);
        }
        setInnerDataNew([...innerDataNew, ...innerdata]);
      }
      setShowLoading(false)
    });
  };
  //load more records in inner handler
  // const onLoadApi = (event) => {'
  //   setopenRowId(event);

  //   const option = {
  //     method: "GET",
  //     headers: {
  //       "content-type": "plain/text",
  //       "X-API-Key": APIUrlToken()
  //     },
  //     url: `${APIUrlThree()}/v1/decision_maker?org_id=${event}&limit=50&skip=${0}`,
  //   };
  //   return axios(option).then((e) => {
  //     if (e?.status === 200) {
  //       const innerdata = e?.data?.data;
  //       if (innerdata?.length === 0) {
  //         setHasMoreInner(false);
  //       } else {
  //       }
  //       return innerdata;
  //     }

  //     return e;
  //   });
  // };

  const onLoadApi = async (id) => {
    setopenRowId(id);
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_list?id=${id || openRowId}&skip=0&limit=20`,
    };

    try {
      const response = await axios(option);
      setLoading(false);
      if (response?.status === 200) {
        setInnerDataNew(response.data);
        const innerdata = response.data || [];

        if (innerdata.length === 0) {
          setHasMoreInner(false);
        }
        return innerdata; // ✅ Return the data
      }
    } catch (err) {
      console.error("Error enriching prospect", err);
      setLoading(false);
      return null; // ✅ Return null or handle error case
    }
  };

  //push to salesforce inner records
  const validateSalesforce = () => {
    if (!selectedRows || selectedRows?.length === 0) {
      setIsSalesForceTrigger(false)
      return false;
    }
    return true;
  };
  const pushToSalesForce = () => {
    if (!validateSalesforce()) return;
    setLoading(true);

    const ms = {
      updateData: {
        data: selectedRows?.map((item) => ({
          items: [item?.person_id, "Suspect"],
        })),
      },
    };
    const transformedData = selectedRows
      ?.map((i) => {
        const organizationInfo =
          organizationList.find((org) => org?.org_id === i?.org_id) || {};
        return { ...i, organizationInfo };
      })
      ?.map((item) => ({
        attributes: {
          type: "Lead",
          referenceId: "rec" + item?.person_id,
        },
        LastName: (item?.last_name),
        FirstName: (item?.first_name),
        Salutation: null,
        Email: item?.email,
        Phone: item?.phone_no,
        Title: item?.primary_job_title,
        Company: item?.primary_organization,
        City: item?.organizationInfo?.location_identifiers?.split(",")[0],
        State: item?.organizationInfo?.location_identifiers?.split(",")[1],
        Country: item?.organizationInfo?.country,
        LeadSource: "JOI",
        Status: "Suspect",
        LinkedIn_Profile__c: item?.linkedin,
        Suspect_Source_Detail__c: `${loggedUser?.firstName} ${loggedUser?.lastName}`,
      }));
    const finalJson = { records: transformedData, ...ms };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken()
      },
      data: finalJson,
      url: `${APIUrlOne()}/v1/add_suspects`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Record has been created");
          const promiseRequest = selectedRows?.map((item) => {
            return ExpandHandler(item?.org_id, 1);
          });
          const result = await Promise.all(promiseRequest);
          setExpandHandlerAccept(...result);
          setSelectedRows([]);
          setMessageModalSalesforce(false)
          setIsSalesForceTrigger(false)
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  //validate and hit salesforce
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      if (!validateSalesforce()) return;
      if (hitApiInner == true) {
        setMessageModalSalesforce(true)
      }
    }
  }, [isSalesForceTrigger]);
  // enable disable salesforce button or not 
  React.useEffect(() => {
    if (selectedRows?.length) {
      const data = selectedRows?.filter((item) => item.suspect_status !== null)
      if (data?.length) {

        setShowSalesForce("disable")
      } else {
        setShowSalesForce("show")
      }
    } else {
      setShowSalesForce(false)
    }
  }, [selectedRows])

  //select organization table rows
  const handleRowSelect = (row) => {
    setSelectedOuterRows(prevSelectedRows => {
      const isAlreadySelected = prevSelectedRows.some(item => item.org_id === row.org_id);

      if (isAlreadySelected) {
        return prevSelectedRows.filter(item => item.org_id !== row.org_id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  //select organization table all rows
  React.useEffect(() => {
    if (rowsSelectAll) {
      const allRows = [...organizationList];
      setSelectedOuterRows(allRows);
    } else if (rowsSelectAll === false) {
      setSelectedOuterRows([]);
    } else if (selectedOuterRows?.length == organizationList?.length) {
      setRowsSelectAll(true)
    } else if (selectedOuterRows?.length < organizationList?.length) {
      setRowsSelectAll(false)
    }
  }, [rowsSelectAll, rowsSelectOuter]);
  // if outer table row selected then api can hit 
  React.useEffect(() => {
    if (selectedOuterRows?.length) {
      setHitApi(true)
    } else {
      setHitApi(false)
    }
  }, [selectedOuterRows])
  // if inner table row selected then api can hit 
  React.useEffect(() => {
    if (selectedRows?.length) {
      setHitApiInner(true)
    } else {
      setHitApiInner(false)
    }
  }, [selectedRows])
  //handle track outer organization records
  const handleTrackRecords = () => {
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to track")
      setTrackRecord(false)
      return
    } else {
      setLoading(true);
      const filteredData = selectedOuterRows.filter((selectedItem) =>
        !trackingData.some(
          (trackingItem) => Number(selectedItem.org_id) === Number(trackingItem.org_id)
        )
      );

      if (filteredData.length === 0) {
        toast.error("All selected records are already tracked.");
        setLoading(false);
        return;
      }

      const data = filteredData.map(item => item?.org_id);
      // const data = selectedOuterRows.map(item => item?.org_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken()
        },
        data: data,
        url: `${APIUrlThree()}/v1/save_tracking_organization?user_id=${Number(GetUserId())}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            setTrackRecord(false)
            setSelectedOuterRows([])
            toast.success("Tracking Added")
            setMessageModalTrack(false);
            handleTrackingdata();
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  }

  //handle track inner prospects records
  const handleTrackPeopleRecords = () => {
    setLoading(true);
    const filteredData = selectedRows.filter((selectedItem) =>
      !trackingData.some(
        (trackingItem) => Number(selectedItem.person_id) === Number(trackingItem.person_id)
      )
    );

    if (filteredData.length === 0) {
      toast.error("All selected records are already tracked.");
      setLoading(false);
      return;
    }

    const data = filteredData.map(item => item?.person_id);
    // const data = selectedOuterRows.map(item => item?.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken()
      },
      data: data,
      url: `${APIUrlThree()}/v1/save_tracking_prospect?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setTrackRecord(false)
          setSelectedRows([])
          setMessageModalTrack(false)
          toast.success("Tracking Added")
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });

  }
  // check which modal to call 
  React.useEffect(() => {
    if (trackRecord === true) {
      if (showLeadsProspects === "leads") {
        if (hitApi === true) {
          setMessageModalTrack(true);
          setTrackRecord(false);
        }
        return;
      } else if (showLeadsProspects === "pros") {
        if (hitApiInner === true) {
          setMessageModalTrack(true);
          setTrackRecord(false);
        }
      } else {
        toast.error("Please select records to track");
        setTrackRecord(false);
        return;
      }

    }

  }, [trackRecord]);

  const handleRemoveFavouriteLead = (row) => {
    // setLoading(true)
    // const data = searchResultsList?.find(item => item?.org_id == row?.org_id)
    // const option = {
    //     method: "POST",
    //     headers: {
    //         "access-control-allow-origin": "*",
    //         "content-type": "application/json",
    //         "X-API-Key": APIUrlToken()
    //     },
    //     // data: data,
    //     url: `${APIUrlThree()}/v1/remove_favourite_leads?id=${data?.favourites_id}`,
    // };
    // axios(option)
    //     .then(async (response) => {
    //         setLoading(false);
    //         // toast.success("Organization removed from favorites")
    //     })
    //     .catch(() => {
    //         setLoading(false);
    //     });
  }

  // archive records
  React.useEffect(() => {
    if (archiveRecord === true) {
      if (showLeadsProspects === "leads") {
        if (hitApi === true) {
          setMessageModalTrack(true);
          setArchiveRecord(false);
        }
        return;
      } else if (showLeadsProspects === "pros") {
        if (hitApiInner === true) {
          setMessageModalTrack(true);
          setArchiveRecord(false);
        }
      } else {
        toast.error("Please select records to Archive");
        setArchiveRecord(false);
        return;
      }

    }
  }, [archiveRecord])
  const handleArchiveRecords = async () => {
    setLoading(true)

    await Promise.all(selectedOuterRows.map(i => handleRemoveFavouriteLead(i)));

    const data = selectedOuterRows.map(item => ({
      user_id: Number(GetUserId()),
      org_id: item?.org_id,
    }));

    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlThree()}/v1/send_archive`,
    };

    try {
      const response = await axios(options);

      setArchiveRecord(false);
      setMessageModal(false);
      setSelectedOuterRows([]);
      listOrganizationSearchResults()
      if (response?.data?.message === "Already archived") {
        toast.success("Organization already archived.");
      } else {
        toast.success("Organization archived successfully.");
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)
      toast.error(error?.response?.data?.message || "Failed to archive organization.");
    }
  };


  return (
    <React.Fragment>
      <>
        <TableContainer component={Paper} className="ai-leads-table-main">

          <Table aria-label="collapsible table" className="ai-leads-table">
            <TableHead>
              <TableRow className="table-row-ai-leads-favlist">
                <TableCell align="left" className="company-row-table-favlist">
                  <input type="checkbox" name="" id="" />
                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">
                  Name
                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">
                  List Name
                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">
                  Date Created
                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">
                  Privacy Status
                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">
                  List Owner
                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">

                </TableCell>
                <TableCell align="left" className="company-row-table-favlist">
                  {/* <div className="createlist-text-img-table" onClick={handleOpen}><p>
                      Create a New List </p><img src={createfolderlogo} alt="" />
                    </div>  */}
                </TableCell>
              </TableRow>
            </TableHead>
            {favoriteSearchData?.filter((item) => item.fav_is_private === false)?.length ?
              <>  
                <TableBody>
                  {favoriteSearchData?.filter((item) => item.fav_is_private === false)?.map((row, index) => {
                    const isSelected = selectedRows?.find(
                      (item) => item?.person_id === row?.person_id
                    );
                    return (
                      <React.Fragment key={index}>
                        <Row
                          key={row.name}
                          row={row}
                          selected={isSelected}
                          onSelect={(selectedRow) => {
                            const localRows = [...selectedRows];
                            const selectedIndex = localRows.findIndex(
                              (row) => row?.person_id === selectedRow?.person_id
                            );
                            let newSelected = [];
                            if (selectedIndex === -1) {
                              newSelected = [selectedRow];
                            } else if (selectedIndex === 0) {
                              newSelected = newSelected.concat(
                                localRows.slice(1)
                              );
                            } else if (selectedIndex === localRows.length - 1) {
                              newSelected = newSelected.concat(
                                localRows.slice(0, -1)
                              );
                            } else if (selectedIndex > 0) {
                              newSelected = localRows.filter(
                                (child) =>
                                  child.person_id !== selectedRow.person_id
                              );
                            }
                            const updatedOrganizations = newSelected.map(
                              (name) => {
                                const organization = organizationList.find(
                                  (org) => org?.org_id === name?.org_id
                                );
                                return {
                                  ...name,
                                  organizationInfo: organization,
                                };
                              }
                            );
                            setSelectedRows(
                              selectedIndex > -1
                                ? updatedOrganizations
                                : [...selectedRows, ...updatedOrganizations]
                            );
                          }}
                          connectionStrength={row.connectionStrength}
                          handleArchiveRecords={handleArchiveRecords}
                          ExpandHandler={ExpandHandler}
                          onLoadApi={onLoadApi}
                          expandHandlerAccept={expandHandlerAccept}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          setPageInner={setPageInner}
                          pageInner={pageInner}
                          openRowId={openRowId}
                          hasMoreInner={hasMoreInner}
                          setExpandHandlerAccept={setExpandHandlerAccept}
                          setopenRowId={setopenRowId}
                          setHasMoreInner={setHasMoreInner}
                          totalPages={totalPages}
                          setRowsSelectOuter={setRowsSelectOuter}
                          selectedOuterRows={selectedOuterRows}
                          organizationList={organizationList}
                          setOrganizationList={setOrganizationList}
                          listOrganizationSearchResults={listOrganizationSearchResults}
                          handleRowSelect={handleRowSelect}
                          showLeadsProspects={showLeadsProspects}
                          setoOenCreateListmdl={setoOenCreateListmdl}
                          setOpenCreateMdl={setOpenCreateMdl}
                          setSelectedOption={setSelectedOption}
                          selectedOption={selectedOption}
                          setListName={setListName}
                          setUpdatelist={setUpdatelist}
                          setUpdatedId={setUpdatedId}
                          setSelectedListId={setSelectedListId}
                          listName={listName} setOpenDeleteModal={setOpenDeleteModal}
                          updatedId={updatedId}
                          selectedListId={selectedListId}
                          innerDataNew={innerDataNew}
                          searchResultPeople={searchResultPeople}
                          searchResultProspects={searchResultProspects}
                          disableOrganizationData={disableOrganizationData}
                          selectedOrganizationData={selectedOrganizationData}
                          handleOrganizationsearch={handleOrganizationsearch}
                          handlePeoplesearch={handlePeoplesearch}
                          headerSearchDataPeople={headerSearchDataPeople}
                          showLoading={showLoading}
                        />
                      </React.Fragment>
                    );
                  })}

                </TableBody>
              </>
              :
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No records found
                </TableCell>
              </TableRow>
            }
          </Table>
        </TableContainer>
      </>

      {/* <div className="loadmore-pagination-section">
        {totalCount !== organizationList?.length && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore} disabled={loading}>{loading ? 'Loading...' : 'Load More'}</button>}
      </div> */}

      <Modal open={openCreateMdl}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <div className="vrufyerv">

          <Box sx={style} style={{ overflowY: "auto" }}>
            <h3 className="type-of-list-fav">Type of Lists <ClearIcon onClick={handleClose} style={{ cursor: 'pointer' }} /></h3>
            <div className="type-of-list-fav-body">
              <RadioGroup value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)} >
                <FormControlLabel className="radio-btn-fav-mdl" value="organization" control={<Radio />} label="Organization" />
                <FormControlLabel className="radio-btn-fav-mdl" value="people" control={<Radio />} label="People" />
              </RadioGroup>
              <div className="de_hr">
                <div className="de_btn_cont">
                  <Button className="de_cancel" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button className="de_next" disabled={!selectedOption} onClick={handleOpenListMdl} style={{ cursor: 'pointer' }}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>


      <Modal open={openCreateListmdl}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <div className="vrufyerv">

          <Box sx={style} style={{ overflowY: "auto" }}>
            <h3 className="type-of-list-fav">Name Your List <ClearIcon onClick={handleCloseListMdl} style={{ cursor: 'pointer' }} /></h3>
            <div className="type-of-list-fav-body">
              <div className="input-list-fav-create">
                <label htmlFor="">List Name</label>
                <input type="text" onChange={(e) => setListName(e.target.value)} value={listName} />
              </div>
              <div className="de_hr">
                <div className="de_btn_cont">
                  <Button className="de_cancel" onClick={handleCloseListMdl}>
                    Cancel
                  </Button>
                  <Button
                    className="de_next"
                    onClick={updatelist ? updateOrgFavList : saveOrgFavList}
                    style={{ cursor: 'pointer' }}
                  >
                    {updatelist ? "Update" : "Next"}
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>

      <Modal open={openDeleteModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto" }}>
            <h3 className="type-of-list-fav">
              Are you sure you want to delete this record?
              <ClearIcon onClick={handleCloseDeleteModal} style={{ cursor: 'pointer' }} />
            </h3>
            <div className="type-of-list-fav-body">
              <div className="de_hr">
                <div className="de_btn_cont">
                  <Button className="de_cancel" onClick={handleCloseDeleteModal}>Cancel</Button>
                  <Button className="de_next" style={{ cursor: 'pointer' }} onClick={deleteFavList}>Delete</Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>

    </React.Fragment >
  );
}
